<template>
  <div class="flex flex-center preview-timer">
    <span class="preview-timer__text" v-text="state.currentTime"></span>
    <PreviewProgress ref="progress" type="timer" @change="handleChangeTime" />
    <span class="preview-timer__text" v-text="state.totalTime"></span>
  </div>
</template>

<script>
import { addEvent, removeEvent } from '@/utils/event'
import PreviewProgress from '../progress'

export default {
  name: 'PreviewTimer',
  components: {
    PreviewProgress
  },
  props: {
    refName: {
      type: String,
      require: true,
      default: 'video'
    }
  },
  data() {
    return {
      state: {
        currentTime: '00:00',
        totalTime: '00:00',
      }
    }
  },
  computed: {
    el() {
      return this.$parent.$refs[this.refName]
    }
  },
  beforeDestroy() {
    removeEvent(this.el, 'canplay', this.handleCanplay)
    removeEvent(this.el, 'timeupdate', this.handleUpdateTimeline)
  },
  mounted() {
    addEvent(this.el, 'canplay', this.handleCanplay)
    addEvent(this.el, 'timeupdate', this.handleUpdateTimeline)
  },
  methods: {
    init() {
      this.state.totalTime = this.timeParse(this.getTotalTime())
    },
    getTotalTime() {
      return this.el.duration === Infinity ? 0 : this.el.duration
    },
    timeParse(time = 0) {
      const hour = 60 * 60
      const h = parseInt(time / hour)
      const m = parseInt(time % hour / 60)
      const s = parseInt(time % 60)
      const result = [m, s]

      if (h) {
        result.unshift(h)
      }

      return result.map(v => `${String(v).padStart(2, '0')}`).join(':')
    },
    handleCanplay() {
      this.init()
    },
    handleUpdateTimeline() {
      const { currentTime, duration } = this.el
      const progress = currentTime / duration

      this.$refs.progress.updateProgress(progress)
      this.state.currentTime = this.timeParse(currentTime)
    },
    handleChangeTime(percent) {
      const totalTime = this.getTotalTime()
      const currentTime = totalTime * percent

      if (isNaN(currentTime)) {
        return false
      }

      if (parseInt(this.el.currentTime) != parseInt(currentTime)) {
        this.el.currentTime = currentTime
      }

      this.state.currentTime = this.timeParse(currentTime)

    }
  }
}
</script>

<style lang="less">
  @import url('~@/styles/var.less');

  .preview-timer {
    flex: 1;
    padding: 0 16px;
    user-select: none;
    & &__text {
      color: @grey-600;
      font-weight: bold;
      font-size: 16px;
      line-height: 16px;
      &:first-child {
        padding-right: 12px;
      }
      &:last-child {
        padding-left: 12px;
      }
    }
  }
</style>
